export default __webpack_public_path__ + "static/media/facet.09c8fb60.png";